import React, { createRef } from 'react'
import FlexView from 'react-flexview/lib'
import { Button, Tooltip, Grid, Paper } from '@material-ui/core'
import Dropzone from 'react-dropzone'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { isMobile } from 'react-device-detect'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import './FileUpload.scss'
import NewFillButton from './NewFillButton'
import { GreenButton } from './Buttons/GreenButton'
import { LinearProgressWithLabel } from './LinearProgressWithLabel'
import { SkyPaper } from './Frames/SkyPaper'

const UPLOAD_STATUS = {
  SELECTING: 'selecting',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  ERROR: 'error',
}

type FileUploadProps = {
  uploadEnabled: Boolean,
  onUpload: Function,
  fileFilter: String,
  successComponenet: Object,
  resetStateText: String,
  reset: Function,
  onFileSelected: Function,
}

export class FileItemView extends React.Component {
  render() {
    return (
      <FlexView className="file-item-view">
        <FlexView className="file-item-view-in" vAlignContent={'center'} hAlignContent={'center'}>
          <InsertDriveFileIcon />
          <Tooltip title={this.props.file.name} placement="top">
            <div className="text-body black file-item-path margin-left-small">{this.props.file.name}</div>
          </Tooltip>
          <FlexView className="clickable" onClick={this.props.remove}>
            <Tooltip placement="top" title="Remove">
              <CloseIcon />
            </Tooltip>
          </FlexView>
        </FlexView>
      </FlexView>
    )
  }
}

export default class FileUpload extends React.Component {
  props: FileUploadProps
  constructor(props) {
    super(props)
    this.state = {
      flight_logs: [],
      upload_status: UPLOAD_STATUS.SELECTING,
      percent: 0,
    }
  }

  dropzone = createRef()

  onDropFlightLog = files => {
    var filesToAdd = []
    for (var i = 0; i < files.length; i++) {
      if (!this.state.flight_logs.find(flightlog => flightlog.name == files[i].name)) filesToAdd.push(files[i])
    }
    this.setState({ flight_logs: [...this.state.flight_logs, ...filesToAdd] })
    this.onFileSelected(filesToAdd)
  }

  onRemoveFlightLog = index => {
    this.setState({ flight_logs: [...this.state.flight_logs.slice(0, index), ...this.state.flight_logs.slice(index + 1)] })
  }

  onSuccess = () => {
    this.setState({
      upload_status: UPLOAD_STATUS.SUCCESS,
    })
  }

  resetState = () => {
    this.setState({
      flight_logs: [],
      upload_status: UPLOAD_STATUS.SELECTING,
      percent: 0,
    })

    this.props.reset && this.props.reset()
  }

  onError = (status, error) => {
    this.setState({
      err_status: status,
      error: error,
      upload_status: UPLOAD_STATUS.ERROR,
    })
  }

  onProgress = percent => {
    this.setState({
      percent: percent,
      upload_status: UPLOAD_STATUS.UPLOADING,
    })
  }

  upload = () => {
    if (this.props.uploadEnabled) {
      this.props.onUpload(this.state.flight_logs, this.onSuccess, this.onError, this.onProgress)
    }
  }

  onFileSelected = files => {
    this.props.onFileSelected && this.props.onFileSelected(files)
  }

  openFileUpload = () => this.dropzone.open()

  render() {
    return (
      <FlexView column>
        <Dropzone ref={ref => (this.dropzone = ref)} multiple accept={this.props.fileFilter} onDrop={this.onDropFlightLog}>
          {({ getRootProps, getInputProps }) => (
            <section className="fit-content">
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                {this.state.flight_logs.length == 0 && this.state.upload_status == UPLOAD_STATUS.SELECTING && (
                  <NewFillButton>
                    <FlexView vAlignContent={'center'}>
                      <CloudUploadIcon />
                      <div className="text-body white margin-left-6">Browse Files</div>
                    </FlexView>
                  </NewFillButton>
                )}
              </div>
            </section>
          )}
        </Dropzone>

        {this.state.upload_status == UPLOAD_STATUS.SELECTING && this.state.flight_logs.length > 0 && (
          <Grid spacing={1} container className="margin-bottom-basic">
            {this.state.flight_logs.map((item, index) => (
              <Grid item key={index}>
                <FileItemView
                  key={index}
                  remove={e => {
                    e.stopPropagation()
                    this.onRemoveFlightLog(index)
                  }}
                  file={item}
                />
              </Grid>
            ))}
          </Grid>
        )}

        {this.state.flight_logs.length > 0 && this.state.upload_status == UPLOAD_STATUS.SELECTING && (
          <FlexView vAlignContent={'center'}>
            <NewFillButton onClick={this.openFileUpload}>
              <FlexView vAlignContent={'center'}>
                <CloudUploadIcon />
                <div className="text-body white margin-left-6">Browse Files</div>
              </FlexView>
            </NewFillButton>
            <GreenButton disabled={!this.props.uploadEnabled} onClick={this.upload}>
              Send my flight logs
            </GreenButton>
          </FlexView>
        )}

        {this.state.upload_status == UPLOAD_STATUS.UPLOADING && (
          <>
            <FlexView vAlignContent={'center'}>
              <FileCopyIcon />
              <div className="text-body black margin-left-6 margin-right-6">Uploading {this.state.flight_logs.length} files</div>
            </FlexView>
            <LinearProgressWithLabel value={this.state.percent} />
          </>
        )}

        {this.state.upload_status == UPLOAD_STATUS.SUCCESS && (
          <SkyPaper className="margin-top-basic">
            <div className="text-promotion bolder black">Awesome!</div>
            <FlexView vAlignContent={'center'} className="margin-top-small">
              <FileCopyIcon className="green" />
              <div className="text-body bold green margin-left-6 margin-right-6">Your files uploaded successfully</div>
              <CheckIcon className="green" />
            </FlexView>
            {this.props.successComponenet}
          </SkyPaper>
        )}

        {this.state.upload_status == UPLOAD_STATUS.ERROR && (
          <FlexView vAlignContent={'center'}>
            <FileCopyIcon />
            <div className="text-body red margin-left-6 margin-right-6">Uploading Flight logs failed</div>
            <CloseIcon className="red" />
          </FlexView>
        )}

        {this.state.upload_status == UPLOAD_STATUS.ERROR || this.state.upload_status == UPLOAD_STATUS.SUCCESS ? (
          <div onClick={this.resetState} className="text-small underline clickable margin-top-basic blue bold">
            {this.props.resetStateText}
          </div>
        ) : undefined}
      </FlexView>
    )
  }
}
